import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatHmd = createCustomElementWrapper('kat-hmd', 'KatHmd', {
    'ratingStyle': 'rating-style',
}, {
    'onClose': 'close',
    'onOpen': 'open',
    'onSubmit': 'submit',
});
